import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MediaService} from "../../services/media/media.service";
import {Media} from "../../models/media";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MediaModal} from "../../modals/media-modal/media-modal.component";
import {merge} from "rxjs";
import {DatabaseService} from "../../services/database/database.service";
import {MessagesService} from "../../services/messages/messages.service";
import { environment } from '../../../environments/environment';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {

    @Input() code: string;
    @Output() mediaOutput: EventEmitter<Array<Media>> = new EventEmitter<Array<Media>>();

    media: Array<Media> = [];
    environment = environment;

    projectId: string;
    databaseId: string;

    constructor(
        private mediaService: MediaService,
        private modalService: NgbModal,
        private messagesService: MessagesService,
        private databaseService: DatabaseService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit() {
      this.projectId = this.route.snapshot.params.project_id;
      this.databaseId = this.route.snapshot.params.database_id;
        merge(
            this.mediaService.getAllMyMedia(this.projectId),
            this.mediaService.onChange
        ).subscribe(
            () => this.media = [...this.mediaService.mediaImages, ...this.mediaService.mediaVideos, ...this.mediaService.mediaAudios],
            e => console.log(e));
    }

    onShowModal() {
        const modalRef = this.modalService.open(MediaModal, {size: 'lg'});
        modalRef.componentInstance.projectId = this.projectId;
        modalRef.componentInstance.media = this.media;
    }

    onDelete(mediaId) {
        this.messagesService.confirmModal().result
            .then(
                result => {
                    if (result) {
                        this.mediaService.deleteMedia(this.projectId, mediaId, this.code)
                            .subscribe(
                                () => {
                                  this.messagesService.successToast('Media deleted.')
                                  this.router.navigateByUrl('projects/' + this.projectId + '/databases/' + this.databaseId);
                                },
                                err => this.messagesService.errorToast(err)
                            );
                    }
                })
            .catch(() => {
            });
    }
}
